<div class="chain-loyalty">
  <!-- Header -->
  <div class="row mb-4">
    <div class="col-md-8">
      <div class="d-flex align-items-center gap-3">
        <button class="btn btn-outline-secondary btn-sm" (click)="goBack()">
          <nb-icon icon="arrow-back-outline"></nb-icon>
        </button>
        <div>
          <h4 class="mb-0">
            <nb-icon icon="award-outline" class="me-2"></nb-icon>
            Chain Loyalty
          </h4>
          <small class="text-muted">Manage loyalty tiers and chain-wide memberships</small>
        </div>
      </div>
    </div>
  </div>

  <!-- Tab navigation -->
  <nb-card class="mb-4">
    <nb-card-body class="p-0">
      <nav class="nav nav-tabs custom-tabs">
        <a class="nav-link" [class.active]="activeTab === 'config'" (click)="setTab('config')" href="javascript:void(0)">
          <nb-icon icon="settings-2-outline" class="me-2"></nb-icon>Configuration
        </a>
        <a class="nav-link" [class.active]="activeTab === 'members'" (click)="setTab('members')" href="javascript:void(0)">
          <nb-icon icon="people-outline" class="me-2"></nb-icon>Members
        </a>
        <a class="nav-link" [class.active]="activeTab === 'vouchers'" (click)="setTab('vouchers')" href="javascript:void(0)">
          <nb-icon icon="pricetags-outline" class="me-2"></nb-icon>Vouchers
          <span *ngIf="vouchers.length > 0" class="badge bg-primary ms-1" style="font-size: 10px;">{{ vouchers.length }}</span>
        </a>
      </nav>
    </nb-card-body>
  </nb-card>

  <!-- ==================== CONFIG TAB ==================== -->
  <div *ngIf="activeTab === 'config'">

    <div *ngIf="configLoading" class="text-center py-5">
      <nb-spinner size="large"></nb-spinner>
      <p class="mt-3 text-muted">Loading configuration...</p>
    </div>

    <div *ngIf="!configLoading">
      <!-- Enable toggle -->
      <nb-card class="mb-4">
        <nb-card-header>
          <h6 class="mb-0">
            <nb-icon icon="toggle-left-outline" class="me-2"></nb-icon>
            General Settings
          </h6>
        </nb-card-header>
        <nb-card-body>
          <div class="row align-items-center">
            <div class="col-md-8">
              <h6 class="mb-1">Enable Chain Loyalty Discount</h6>
              <small class="text-muted">When enabled, configured discounts will be applied to eligible chain members at checkout.</small>
            </div>
            <div class="col-md-4 text-end">
              <nb-toggle [(checked)]="isEnabled" status="success"></nb-toggle>
              <span class="ms-2" [class.text-success]="isEnabled" [class.text-muted]="!isEnabled">
                {{ isEnabled ? 'Enabled' : 'Disabled' }}
              </span>
            </div>
          </div>

          <hr>

          <div class="row mt-3">
            <div class="col-md-4">
              <label class="form-label">Birthday Discount Rate (%)</label>
              <div class="input-group" style="max-width: 200px;">
                <input type="number" class="form-control" [(ngModel)]="birthdayDiscountRate" min="0" max="100" step="1">
                <span class="input-group-text">%</span>
              </div>
              <small class="form-text text-muted">Applied automatically on the customer's birthday</small>
            </div>
          </div>
        </nb-card-body>
      </nb-card>

      <!-- Tiers -->
      <nb-card class="mb-4">
        <nb-card-header>
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="mb-0">
              <nb-icon icon="star-outline" class="me-2"></nb-icon>
              Loyalty Tiers
            </h6>
            <button class="btn btn-sm btn-outline-primary" (click)="addTier()">
              <nb-icon icon="plus-outline"></nb-icon>
              Add Tier
            </button>
          </div>
        </nb-card-header>
        <nb-card-body>
          <div *ngIf="tiers.length === 0" class="text-center py-3 text-muted">
            No tiers configured. Click "Add Tier" to get started.
          </div>

          <div class="table-responsive" *ngIf="tiers.length > 0">
            <table class="table table-bordered align-middle">
              <thead class="table-light">
                <tr>
                  <th>Label</th>
                  <th>Key</th>
                  <th>Discount %</th>
                  <th>Min Cart</th>
                  <th>1st Purchase Bonus %</th>
                  <th style="width:60px;"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let tier of tiers; let i = index; trackBy: trackByIndex">
                  <td>
                    <input type="text" class="form-control form-control-sm" [(ngModel)]="tier.label"
                      (ngModelChange)="onTierLabelChange(tier)" placeholder="e.g. Member">
                  </td>
                  <td>
                    <input type="text" class="form-control form-control-sm" [(ngModel)]="tier.tierKey"
                      placeholder="e.g. member">
                  </td>
                  <td>
                    <div class="input-group input-group-sm">
                      <input type="number" class="form-control" [(ngModel)]="tier.discountRate" min="0" max="100">
                      <span class="input-group-text">%</span>
                    </div>
                  </td>
                  <td>
                    <input type="number" class="form-control form-control-sm" [(ngModel)]="tier.minCartAmount" min="0"
                      placeholder="0 = none">
                  </td>
                  <td>
                    <div class="input-group input-group-sm">
                      <input type="number" class="form-control" [(ngModel)]="tier.firstPurchaseBonusRate" min="0" max="100">
                      <span class="input-group-text">%</span>
                    </div>
                  </td>
                  <td class="text-center">
                    <button class="btn btn-sm btn-outline-danger" (click)="removeTier(i)">
                      <nb-icon icon="trash-outline"></nb-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </nb-card-body>
      </nb-card>

      <!-- Promotion Rules -->
      <nb-card class="mb-4">
        <nb-card-header>
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="mb-0">
              <nb-icon icon="trending-up-outline" class="me-2"></nb-icon>
              Promotion Rules
              <small class="text-muted ms-2 fw-normal">(automatic tier assignment)</small>
            </h6>
            <button class="btn btn-sm btn-outline-primary" (click)="addPromotionRule()">
              <nb-icon icon="plus-outline"></nb-icon>
              Add Rule
            </button>
          </div>
        </nb-card-header>
        <nb-card-body>
          <div *ngIf="promotionRules.length === 0" class="text-center py-3 text-muted">
            No promotion rules configured.
          </div>

          <div class="table-responsive" *ngIf="promotionRules.length > 0">
            <table class="table table-bordered align-middle">
              <thead class="table-light">
                <tr>
                  <th>Tier</th>
                  <th>Required Spend (DKK)</th>
                  <th>Required Visits</th>
                  <th style="width:60px;"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let rule of promotionRules; let i = index; trackBy: trackByIndex">
                  <td>
                    <select class="form-select form-select-sm" [(ngModel)]="rule.tierKey">
                      <option value="">Select tier</option>
                      <option *ngFor="let t of tiers" [value]="t.tierKey">{{ t.label || t.tierKey }}</option>
                    </select>
                  </td>
                  <td>
                    <input type="number" class="form-control form-control-sm" [(ngModel)]="rule.requiredSpend" min="0"
                      placeholder="0 = any">
                  </td>
                  <td>
                    <input type="number" class="form-control form-control-sm" [(ngModel)]="rule.requiredVisits" min="0"
                      placeholder="0 = any">
                  </td>
                  <td class="text-center">
                    <button class="btn btn-sm btn-outline-danger" (click)="removePromotionRule(i)">
                      <nb-icon icon="trash-outline"></nb-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </nb-card-body>
      </nb-card>

      <!-- Save button -->
      <div class="d-flex justify-content-end mb-4">
        <button class="btn btn-success px-4" (click)="saveConfig()" [disabled]="configSaving">
          <nb-icon *ngIf="configSaving" icon="loader-outline" class="me-2"></nb-icon>
          <nb-icon *ngIf="!configSaving" icon="save-outline" class="me-2"></nb-icon>
          {{ configSaving ? 'Saving...' : 'Save Configuration' }}
        </button>
      </div>
    </div>
  </div>

  <!-- ==================== MEMBERS TAB ==================== -->
  <div *ngIf="activeTab === 'members'">

    <!-- Toolbar -->
    <nb-card class="mb-4">
      <nb-card-body>
        <div class="row align-items-center">
          <div class="col-md-4">
            <div class="input-group">
              <input type="text" class="form-control" placeholder="Search by name or email..."
                [(ngModel)]="memberSearch" (keyup.enter)="onMemberSearchChange()">
              <button class="btn btn-outline-secondary" (click)="onMemberSearchChange()">
                <nb-icon icon="search-outline"></nb-icon>
              </button>
            </div>
          </div>
          <div class="col-md-3">
            <select class="form-select" [(ngModel)]="memberTierFilter" (change)="onMemberSearchChange()">
              <option value="">All Tiers</option>
              <option *ngFor="let t of tiers" [value]="t.tierKey">{{ t.label }}</option>
            </select>
          </div>
          <div class="col-md-3">
            <select class="form-select" [(ngModel)]="memberActiveFilter" (change)="onMemberSearchChange()">
              <option value="all">All Status</option>
              <option value="active">Active only</option>
              <option value="inactive">Inactive only</option>
            </select>
          </div>
          <div class="col-md-2 text-end">
            <button class="btn btn-primary" (click)="openAddMemberDialog()">
              <nb-icon icon="person-add-outline"></nb-icon>
              Add Member
            </button>
          </div>
        </div>
      </nb-card-body>
    </nb-card>

    <!-- Members Table -->
    <nb-card>
      <nb-card-body class="p-0">
        <div *ngIf="membersLoading" class="text-center py-4">
          <nb-spinner size="medium"></nb-spinner>
        </div>

        <div *ngIf="!membersLoading">
          <div class="table-responsive">
            <table class="table table-hover mb-0">
              <thead class="table-light">
                <tr>
                  <th>Customer</th>
                  <th>Tier</th>
                  <th>Scope</th>
                  <th>Assigned</th>
                  <th>Expires</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let m of members; trackBy: trackById">
                  <td>
                    <strong>{{ m.userId?.name || '—' }}</strong><br>
                    <small class="text-muted">{{ m.userId?.email || '' }}</small>
                  </td>
                  <td>
                    <span class="badge {{ getTierBadgeClass(m.tierKey) }}">
                      {{ getTierLabel(m.tierKey) }}
                    </span>
                  </td>
                  <td>
                    <span class="badge chain-badge">
                      <nb-icon icon="link-2-outline" class="me-1" style="font-size: 10px;"></nb-icon>
                      Chain-wide
                    </span>
                  </td>
                  <td>{{ formatDate(m.assignedAt) }}</td>
                  <td>{{ formatDate(m.expiresAt) }}</td>
                  <td>
                    <span class="badge" [class.bg-success]="m.isActive" [class.bg-secondary]="!m.isActive">
                      {{ m.isActive ? 'Active' : 'Inactive' }}
                    </span>
                  </td>
                  <td>
                    <div class="d-flex gap-1">
                      <button class="btn btn-sm btn-outline-primary" (click)="openEditMemberDialog(m)" nbTooltip="Edit">
                        <nb-icon icon="edit-outline"></nb-icon>
                      </button>
                      <button class="btn btn-sm"
                        [class.btn-outline-warning]="m.isActive"
                        [class.btn-outline-success]="!m.isActive"
                        (click)="toggleMemberActive(m)"
                        [nbTooltip]="m.isActive ? 'Deactivate' : 'Reactivate'">
                        <nb-icon [icon]="m.isActive ? 'pause-circle-outline' : 'play-circle-outline'"></nb-icon>
                      </button>
                      <button class="btn btn-sm btn-outline-danger" (click)="deleteMember(m._id)" nbTooltip="Remove">
                        <nb-icon icon="trash-outline"></nb-icon>
                      </button>
                    </div>
                  </td>
                </tr>
                <tr *ngIf="members.length === 0">
                  <td colspan="7" class="text-center py-4 text-muted">No chain members found.</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Pagination -->
          <div *ngIf="membersTotal > membersLimit" class="d-flex justify-content-between align-items-center p-3 border-top">
            <small class="text-muted">Showing {{ (membersPage - 1) * membersLimit + 1 }}–{{ membersPage * membersLimit > membersTotal ? membersTotal : membersPage * membersLimit }} of {{ membersTotal }}</small>
            <nav>
              <ul class="pagination pagination-sm mb-0">
                <li class="page-item" [class.disabled]="membersPage === 1">
                  <a class="page-link" href="javascript:void(0)" (click)="membersPage > 1 && onMemberPageChange(1)" title="First">««</a>
                </li>
                <li class="page-item" [class.disabled]="membersPage === 1">
                  <a class="page-link" href="javascript:void(0)" (click)="membersPage > 1 && onMemberPageChange(membersPage - 1)">«</a>
                </li>
                <li class="page-item" *ngFor="let p of getMemberPages()" [class.active]="p === membersPage">
                  <a class="page-link" href="javascript:void(0)" (click)="onMemberPageChange(p)">{{ p }}</a>
                </li>
                <li class="page-item" [class.disabled]="membersPage === membersTotalPages">
                  <a class="page-link" href="javascript:void(0)" (click)="membersPage < membersTotalPages && onMemberPageChange(membersPage + 1)">»</a>
                </li>
                <li class="page-item" [class.disabled]="membersPage === membersTotalPages">
                  <a class="page-link" href="javascript:void(0)" (click)="membersPage < membersTotalPages && onMemberPageChange(membersTotalPages)" title="Last">»»</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </nb-card-body>
    </nb-card>
  </div>
</div>

<!-- ==================== VOUCHERS TAB ==================== -->
<div *ngIf="activeTab === 'vouchers'">

  <!-- Toolbar -->
  <nb-card class="mb-4">
    <nb-card-body>
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <h6 class="mb-0">
            <nb-icon icon="pricetags-outline" class="me-2"></nb-icon>
            Chain Vouchers
          </h6>
          <small class="text-muted">Vouchers valid at all stores in this chain</small>
        </div>
        <button class="btn btn-primary" (click)="openCreateVoucherDialog()">
          <nb-icon icon="plus-outline" class="me-1"></nb-icon>
          Add Voucher
        </button>
      </div>
    </nb-card-body>
  </nb-card>

  <!-- Vouchers Table -->
  <nb-card>
    <nb-card-body class="p-0">
      <div *ngIf="vouchersLoading" class="text-center py-4">
        <nb-spinner size="medium"></nb-spinner>
      </div>

      <div *ngIf="!vouchersLoading">
        <div class="table-responsive">
          <table class="table table-hover mb-0">
            <thead class="table-light">
              <tr>
                <th>Code</th>
                <th>Type</th>
                <th>Value</th>
                <th>Usage</th>
                <th>Expires</th>
                <th>Scope</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let v of vouchers; trackBy: trackById">
                <td>
                  <code class="fw-bold" style="font-size: 13px;">{{ v.code }}</code>
                </td>
                <td>
                  <span class="badge" [class.bg-info]="v.discountType === 'percentage'" [class.bg-warning]="v.discountType === 'fixed'" [class.text-dark]="v.discountType === 'fixed'">
                    {{ v.discountType === 'percentage' ? 'Percentage' : 'Fixed' }}
                  </span>
                </td>
                <td>
                  <strong>{{ v.discountType === 'percentage' ? v.value + '%' : v.value + ' DKK' }}</strong>
                </td>
                <td>
                  <span *ngIf="v.usageLimit === 0">Unlimited</span>
                  <span *ngIf="v.usageLimit > 0">{{ v.usedCount || 0 }} / {{ v.usageLimit }}</span>
                </td>
                <td>{{ formatDate(v.expiresAt) }}</td>
                <td>
                  <span class="badge chain-badge">
                    <nb-icon icon="link-2-outline" class="me-1" style="font-size: 10px;"></nb-icon>
                    All stores in chain
                  </span>
                </td>
                <td>
                  <span class="badge" [class.bg-success]="v.isActive" [class.bg-secondary]="!v.isActive">
                    {{ v.isActive ? 'Active' : 'Inactive' }}
                  </span>
                </td>
                <td>
                  <div class="d-flex gap-1">
                    <button class="btn btn-sm btn-outline-primary" (click)="openEditVoucherDialog(v)" nbTooltip="Edit">
                      <nb-icon icon="edit-outline"></nb-icon>
                    </button>
                    <button class="btn btn-sm"
                      [class.btn-outline-warning]="v.isActive"
                      [class.btn-outline-success]="!v.isActive"
                      (click)="toggleVoucherActive(v)"
                      [nbTooltip]="v.isActive ? 'Deactivate' : 'Activate'">
                      <nb-icon [icon]="v.isActive ? 'pause-circle-outline' : 'play-circle-outline'"></nb-icon>
                    </button>
                    <button class="btn btn-sm btn-outline-danger" (click)="deleteVoucher(v._id)" nbTooltip="Delete">
                      <nb-icon icon="trash-outline"></nb-icon>
                    </button>
                  </div>
                </td>
              </tr>
              <tr *ngIf="vouchers.length === 0">
                <td colspan="8" class="text-center py-5 text-muted">
                  <nb-icon icon="pricetags-outline" style="font-size: 32px; opacity: 0.3;"></nb-icon>
                  <p class="mt-2 mb-0">No chain vouchers yet. Click "Add Voucher" to create one.</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </nb-card-body>
  </nb-card>
</div>

<!-- ==================== ADD MEMBER DIALOG ==================== -->
<div *ngIf="showAddMemberDialog" class="modal-backdrop-custom">
  <nb-card class="dialog-card">
    <nb-card-header>
      <div class="d-flex justify-content-between align-items-center">
        <h5 class="mb-0">Add Chain Loyalty Member</h5>
        <button class="btn btn-outline-secondary btn-sm" (click)="closeAddMemberDialog()">
          <nb-icon icon="close-outline"></nb-icon>
        </button>
      </div>
    </nb-card-header>
    <nb-card-body>
      <div class="alert alert-info d-flex align-items-center gap-2 mb-3" style="font-size: 13px;">
        <nb-icon icon="link-2-outline"></nb-icon>
        This membership will be valid chain-wide across all stores in this chain.
      </div>
      <form [formGroup]="addMemberForm">
        <div class="mb-3">
          <label class="form-label">Search Customer *</label>
          <div class="input-group">
            <input type="text" class="form-control" formControlName="userSearch"
              placeholder="Type name or email..."
              (input)="onUserSearchInput()"
              (keyup.enter)="searchUsers()">
            <button class="btn btn-outline-secondary" type="button" (click)="searchUsers()">
              <nb-icon icon="search-outline"></nb-icon>
            </button>
          </div>
          <div *ngIf="userSearchLoading" class="mt-2 text-muted small">Searching...</div>
          <div *ngIf="userSearchResults.length > 0" class="user-search-results border rounded mt-1">
            <a *ngFor="let u of userSearchResults"
              class="d-flex align-items-center p-2 text-decoration-none border-bottom user-result-row"
              href="javascript:void(0)"
              (click)="selectUser(u)">
              <nb-icon icon="person-outline" class="me-2 text-muted"></nb-icon>
              <div>
                <strong>{{ u.name || u.fullName }}</strong>
                <small class="text-muted d-block">{{ u.email }}</small>
              </div>
            </a>
          </div>
          <input type="hidden" formControlName="userId">
          <div *ngIf="addMemberForm.get('userId')?.invalid && addMemberForm.get('userId')?.touched" class="text-danger small mt-1">
            Please select a customer from search results
          </div>
        </div>

        <div class="mb-3">
          <label class="form-label">Loyalty Tier *</label>
          <select class="form-select" formControlName="tierKey">
            <option value="">Select a tier</option>
            <option *ngFor="let t of tiers" [value]="t.tierKey">{{ t.label }} ({{ t.discountRate }}% discount)</option>
          </select>
          <div *ngIf="addMemberForm.get('tierKey')?.invalid && addMemberForm.get('tierKey')?.touched" class="text-danger small mt-1">
            Please select a tier
          </div>
        </div>

        <div class="mb-3">
          <label class="form-label">Expiry Date (optional)</label>
          <input type="date" class="form-control" formControlName="expiresAt">
          <small class="form-text text-muted">Leave empty for no expiry</small>
        </div>
      </form>
    </nb-card-body>
    <nb-card-footer>
      <div class="d-flex justify-content-end gap-2">
        <button class="btn btn-outline-secondary" (click)="closeAddMemberDialog()">Cancel</button>
        <button class="btn btn-primary" (click)="submitAddMember()" [disabled]="addMemberSubmitting">
          <nb-icon *ngIf="addMemberSubmitting" icon="loader-outline" class="me-1"></nb-icon>
          {{ addMemberSubmitting ? 'Adding...' : 'Add Member' }}
        </button>
      </div>
    </nb-card-footer>
  </nb-card>
</div>

<!-- ==================== EDIT MEMBER DIALOG ==================== -->
<div *ngIf="showEditMemberDialog" class="modal-backdrop-custom">
  <nb-card class="dialog-card">
    <nb-card-header>
      <div class="d-flex justify-content-between align-items-center">
        <h5 class="mb-0">Edit Chain Membership</h5>
        <button class="btn btn-outline-secondary btn-sm" (click)="closeEditMemberDialog()">
          <nb-icon icon="close-outline"></nb-icon>
        </button>
      </div>
    </nb-card-header>
    <nb-card-body>
      <p class="text-muted mb-3">
        Editing chain-wide membership for <strong>{{ editingMembership?.userId?.name }}</strong>
      </p>
      <form [formGroup]="editMemberForm">
        <div class="mb-3">
          <label class="form-label">Loyalty Tier *</label>
          <select class="form-select" formControlName="tierKey">
            <option value="" disabled>Select a tier</option>
            <option *ngFor="let t of tiers" [value]="t.tierKey">{{ t.label }} ({{ t.discountRate }}%)</option>
          </select>
        </div>
        <div class="mb-3">
          <label class="form-label">Expiry Date</label>
          <input type="date" class="form-control" formControlName="expiresAt">
          <small class="form-text text-muted">Leave empty to remove expiry</small>
        </div>
        <div class="mb-3">
          <div class="form-check">
            <input type="checkbox" class="form-check-input" formControlName="isActive" id="editMemberActive">
            <label class="form-check-label" for="editMemberActive">Active</label>
          </div>
        </div>
      </form>
    </nb-card-body>
    <nb-card-footer>
      <div class="d-flex justify-content-end gap-2">
        <button class="btn btn-outline-secondary" (click)="closeEditMemberDialog()">Cancel</button>
        <button class="btn btn-primary" (click)="submitEditMember()" [disabled]="editMemberSubmitting">
          <nb-icon *ngIf="editMemberSubmitting" icon="loader-outline" class="me-1"></nb-icon>
          {{ editMemberSubmitting ? 'Saving...' : 'Save Changes' }}
        </button>
      </div>
    </nb-card-footer>
  </nb-card>
</div>

<!-- ==================== VOUCHER DIALOG ==================== -->
<div *ngIf="showVoucherDialog" class="modal-backdrop-custom">
  <nb-card class="dialog-card">
    <nb-card-header>
      <div class="d-flex justify-content-between align-items-center">
        <h5 class="mb-0">{{ editingVoucher ? 'Edit Voucher' : 'Add Chain Voucher' }}</h5>
        <button class="btn btn-outline-secondary btn-sm" (click)="closeVoucherDialog()">
          <nb-icon icon="close-outline"></nb-icon>
        </button>
      </div>
    </nb-card-header>
    <nb-card-body>
      <div class="alert alert-info d-flex align-items-center gap-2 mb-3" style="font-size: 13px;">
        <nb-icon icon="link-2-outline"></nb-icon>
        This voucher will be valid at all stores in this chain.
      </div>
      <form [formGroup]="voucherForm">
        <div class="mb-3">
          <label class="form-label">Voucher Code *</label>
          <input type="text" class="form-control text-uppercase" formControlName="code"
            placeholder="e.g. CHAIN20OFF"
            [readonly]="!!editingVoucher"
            (input)="onVoucherCodeInput($event)"
            style="letter-spacing: 1px; font-family: monospace;">
          <small class="form-text text-muted">Letters and numbers only — automatically uppercased</small>
          <div *ngIf="voucherForm.get('code')?.invalid && voucherForm.get('code')?.touched" class="text-danger small mt-1">
            Code is required
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-6">
            <label class="form-label">Discount Type *</label>
            <select class="form-select" formControlName="discountType" [attr.disabled]="editingVoucher ? true : null">
              <option value="percentage">Percentage (%)</option>
              <option value="fixed">Fixed Amount (DKK)</option>
            </select>
          </div>
          <div class="col-md-6">
            <label class="form-label">Discount Value *</label>
            <div class="input-group">
              <input type="number" class="form-control" formControlName="value" min="0"
                [readonly]="!!editingVoucher">
              <span class="input-group-text">
                {{ voucherForm.get('discountType')?.value === 'percentage' ? '%' : 'DKK' }}
              </span>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-6">
            <label class="form-label">Usage Limit</label>
            <input type="number" class="form-control" formControlName="usageLimit" min="0"
              placeholder="0 = unlimited">
            <small class="form-text text-muted">0 means unlimited uses</small>
          </div>
          <div class="col-md-6">
            <label class="form-label">Expiry Date</label>
            <input type="date" class="form-control" formControlName="expiresAt">
            <small class="form-text text-muted">Leave empty for no expiry</small>
          </div>
        </div>

        <div class="mb-3" *ngIf="!editingVoucher">
          <label class="form-label">Description (optional)</label>
          <input type="text" class="form-control" formControlName="description"
            placeholder="e.g. Chain launch promo">
        </div>

        <div class="mb-3" *ngIf="editingVoucher">
          <div class="form-check">
            <input type="checkbox" class="form-check-input" formControlName="isActive" id="voucherActive">
            <label class="form-check-label" for="voucherActive">Active</label>
          </div>
        </div>
      </form>
    </nb-card-body>
    <nb-card-footer>
      <div class="d-flex justify-content-end gap-2">
        <button class="btn btn-outline-secondary" (click)="closeVoucherDialog()">Cancel</button>
        <button class="btn btn-primary" (click)="submitVoucher()" [disabled]="voucherSubmitting">
          <nb-icon *ngIf="voucherSubmitting" icon="loader-outline" class="me-1"></nb-icon>
          {{ voucherSubmitting ? 'Saving...' : (editingVoucher ? 'Save Changes' : 'Create Voucher') }}
        </button>
      </div>
    </nb-card-footer>
  </nb-card>
</div>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="large" [fullScreen]="true" color="white" type="ball-circus">
  <p style="color: white">Loading...</p>
</ngx-spinner>
